import { createApi } from '@reduxjs/toolkit/query/react';

import {
  PaymentAccountsEndpoints as Endpoints,
  type GetPaymentAccountByIdRequest,
  type GetPaymentAccountByIdResponse,
  type GetPaymentAccountsForSystemRequest,
  type GetPaymentAccountsForSystemResponse,
  type GetPaymentAccountsRequest,
  type GetPaymentAccountsResponse,
  type MakeMoneyCollectionRequest,
  type MakeMoneyCollectionResponse,
  type UpdatePaymentAccountBalanceRequest,
  type UpdatePaymentAccountBalanceResponse,
  type UpdatePaymentAccountRequest,
  type UpdatePaymentAccountResponse,
} from '@app/api/PaymentAccounts/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { PAYMENT_ACCOUNTS } from '@app/constants';

export const paymentAccountsApi = createApi({
  reducerPath: 'paymentAccountsApi',
  baseQuery: createApiBaseQuery(PAYMENT_ACCOUNTS),
  endpoints: ({ mutation, query }) => ({
    [Endpoints.UpdatePaymentAccount]: mutation<
      UpdatePaymentAccountResponse,
      UpdatePaymentAccountRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.UpdatePaymentAccount,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.GetPaymentAccounts]: query<
      GetPaymentAccountsResponse,
      GetPaymentAccountsRequest
    >({
      query: (params) => ({
        url: Endpoints.GetPaymentAccounts,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.GetPaymentAccountsForSystem]: query<
      GetPaymentAccountsForSystemResponse,
      GetPaymentAccountsForSystemRequest
    >({
      query: (params) => ({
        url: Endpoints.GetPaymentAccountsForSystem,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.UpdatePaymentAccountBalance]: mutation<
      UpdatePaymentAccountBalanceResponse,
      UpdatePaymentAccountBalanceRequest
    >({
      query: (params) => ({
        url: Endpoints.UpdatePaymentAccountBalance,
        method: Methods.POST,
        params,
      }),
    }),
    [Endpoints.MakeMoneyCollection]: mutation<
      MakeMoneyCollectionResponse,
      MakeMoneyCollectionRequest
    >({
      query: (params) => ({
        url: Endpoints.MakeMoneyCollection,
        method: Methods.POST,
        params,
      }),
    }),
    [Endpoints.GetPaymentAccountById]: query<
      GetPaymentAccountByIdResponse,
      GetPaymentAccountByIdRequest
    >({
      query: (params) => ({
        url: Endpoints.GetPaymentAccountById,
        method: Methods.GET,
        params,
      }),
    }),
  }),
});

export const {
  useUpdatePaymentAccountMutation,
  useGetPaymentAccountsQuery,
  useLazyGetPaymentAccountsQuery,
  useGetPaymentAccountsForSystemQuery,
  useLazyGetPaymentAccountsForSystemQuery,
  useUpdatePaymentAccountBalanceMutation,
  useMakeMoneyCollectionMutation,
  useGetPaymentAccountByIdQuery,
  useLazyGetPaymentAccountByIdQuery,
} = paymentAccountsApi;
